import React from 'react'
import { useLocation } from '@scentregroup/shared/next/compat/location'
import { CoreContainer } from '@hub/core-container'
import {
  EmbeddedSearch,
  SegmentHits,
  CentreSearchFields,
} from '@scentregroup/shared/components/search'
import { useCountry } from '@scentregroup/shared/country'

interface SearchResultProps {
  centre?: CentreSearchFields
  algoliaResults?: SegmentHits
}

const SearchResultsPage: React.FC<
  React.PropsWithChildren<SearchResultProps>
> = ({ centre, algoliaResults }) => {
  const { search } = useLocation()
  const showFixedQuery = new URLSearchParams(search).get('q') || ''
  const country = useCountry()
  return (
    <CoreContainer>
      <EmbeddedSearch
        algoliaResults={algoliaResults}
        country={country}
        showFixedQuery={showFixedQuery}
        centre={centre}
      />
    </CoreContainer>
  )
}

export default SearchResultsPage
